import { LocalStorageItemDto, LocalStorageConfigDto } from './local-storage.dto';

export const mockLocalStorageItemDto: LocalStorageItemDto = {
  key: 'test-key',
  value: 'eyJzZXR0aW5ncyI6eyJ0aGVtZSI6ImRhcmsifX0=', // base64 encoded JSON
  timestamp: Date.now(),
};

export const mockLocalStorageConfigDto: LocalStorageConfigDto = {
  prefix: 'app:noova-energy',
  chunkSize: 100000,
  enableCompression: true,
};